import RepositoryFactory from '@/repository/RepositoryFactory';
import { PostDutyRequest, PutDutyRequest } from '@/model/repository';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * 業務を取得
 */
export async function fetchDuties() {
  const fetchedDuties = await shiftServiceRepositories.duties.index();
  return fetchedDuties.data;
}

/**
 * 業務を更新
 */
export async function updateDuties(id: string, payload: PutDutyRequest) {
  const fetchedDuties = await shiftServiceRepositories.duties.update(id, payload);
  return fetchedDuties.data;
}

/**
 * 業務を作成
 */
export async function storeDuties(payload: PostDutyRequest) {
  const fetchedDuties = await shiftServiceRepositories.duties.create(payload);
  return fetchedDuties.data;
}

export default {
  fetchDuties,
  updateDuties,
  storeDuties,
};
